import { useDispatch } from 'react-redux'
import { createWorkorder, getWorkorders } from 'app/workorder/state/workorder/actions'
import { IWorkorderResponse } from '@cbgms/api'
import { query } from '@cbgms/components/list'

/**
 * useGetOrCreateOrderUUIDForVehicle always returns a uuid for a vehicle-workorder that might already exists
 * If none exists yet, it'll create a new vehicle-workorder.
 */
export const useGetOrCreateOrderUUIDForVehicle = () => {
  const dispatch = useDispatch()

  return async (vehicleUUID: string, accountUUID?: string) => {
    const search = query<IWorkorderResponse>().equals(o => o.Vehicle.UUID, vehicleUUID)
    const orders = await dispatch(getWorkorders({ search: search.toString(), orderBy: 'Workorder.CreatedAt|DESC' }))
    if (orders.Data.length) {
      const firstOrder = orders.Data[0]
      return firstOrder.Workorder.UUID
    }

    // no open order, create a new employee order
    const response = await dispatch(createWorkorder({ AccountUUID: accountUUID || undefined, VehicleUUID: vehicleUUID || undefined }))
    return response.Data.UUID
  }
}
